export class IncantorWebTelemetry {
  static instance = null;

  constructor() {
    this.endpoint = (process.env.REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT || "https://otlp.nr-data.net:4318").replace(/\/$/, "");
    this.serviceName = process.env.REACT_APP_OTEL_SERVICE_NAME || "incantor-frontend";
    this.apiKey = process.env.REACT_APP_NEW_RELIC_LICENSE_KEY || "4e9bea5fd298c57b30988ada355b21a2FFFFNRAL";

    if (typeof window !== "undefined") {
      window.addEventListener("error", (event) => this.recordError(event.error || new Error(event.message)));
      window.addEventListener("unhandledrejection", (event) => {
        const reason = event.reason;
        const err = reason instanceof Error ? reason : new Error(String(reason));
        this.recordError(err);
      });
      this.recordPageView(window.location.pathname);
    }
  }

  static getInstance() {
    if (!IncantorWebTelemetry.instance) {
      IncantorWebTelemetry.instance = new IncantorWebTelemetry();
    }
    return IncantorWebTelemetry.instance;
  }

  recordPageView(path) {
    const spanId = this.generateHex(8);
    const traceId = this.generateHex(16);

    this.sendSpan({
      traceId,
      spanId,
      name: `browser.page_view: ${path}`,
      kind: 1,
      startTimeUnixNano: String(Date.now() * 1_000_000),
      endTimeUnixNano: String(Date.now() * 1_000_000),
      status: { code: 1 },
      attributes: [
        { key: "component", value: { stringValue: "frontend_browser" } },
        { key: "browser.path", value: { stringValue: path } },
        { key: "browser.url", value: { stringValue: window.location.href } },
      ],
    });
  }

  recordError(error, extraAttributes) {
    const spanId = this.generateHex(8);
    const traceId = this.generateHex(16);

    const attributes = [
      { key: "component", value: { stringValue: "frontend_browser" } },
      { key: "error", value: { boolValue: true } },
      { key: "error.message", value: { stringValue: error.message } },
      { key: "exception.type", value: { stringValue: error.name || "Error" } },
      { key: "exception.message", value: { stringValue: error.message } },
      { key: "exception.stacktrace", value: { stringValue: error.stack || "" } },
      { key: "browser.url", value: { stringValue: window.location.href } },
      { key: "page.url", value: { stringValue: window.location.href } },
      { key: "browser.path", value: { stringValue: window.location.pathname } },
    ];

    if (extraAttributes) {
      for (const [k, v] of Object.entries(extraAttributes)) {
        attributes.push({ key: k, value: { stringValue: String(v) } });
      }
    }

    this.sendSpan({
      traceId,
      spanId,
      name: `browser.error: ${error.name || "JavaScriptError"}`,
      kind: 1,
      startTimeUnixNano: String(Date.now() * 1_000_000),
      endTimeUnixNano: String(Date.now() * 1_000_000),
      status: { code: 2, message: error.message },
      attributes,
    });
  }

  sendSpan(span) {
    const payload = {
      resourceSpans: [
        {
          resource: {
            attributes: [
              { key: "service.name", value: { stringValue: this.serviceName } },
              { key: "deployment.environment", value: { stringValue: process.env.NODE_ENV || "production" } },
            ],
          },
          scopeSpans: [
            {
              scope: { name: "incantor-web-client", version: "1.0.0" },
              spans: [span],
            },
          ],
        },
      ],
    };

    fetch(`${this.endpoint}/v1/traces`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "api-key": this.apiKey,
      },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  }

  generateHex(bytes) {
    return Array.from(crypto.getRandomValues(new Uint8Array(bytes)))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  }
}
